import { createContext } from "react";

const PageContext = createContext({
  roomDetail: {},
  showBannerPadding: false,
  location: "",
  hotel: {},
  tabActive: "",
  reason: "",
  destination: "",
  subDestination: "",
  ignoreBookingCodeFromUrl: false,
  isQuarantinePackage: false,
});

export default PageContext;
